export const messages = {
  en: {
    componentConditionManage: {
      condition: 'Condition',
      conditionId: 'Condition ID',
      name: 'Name',
      holdpace: 'Holdpace',
      param: 'Param',
      type: 'Type',
      seq: 'Sequence',
      remark: 'Remark',
      text: 'Text',
      date: 'Date',
      fetchError: 'Failed to fetch component conditions',
      requiredName: 'Required, please enter name',
      requiredHoldpace: 'Required, please enter holdpace',
      requiredParam: 'Required, please enter param',
      requiredType: 'Required, please select type',
      requiredSeq: 'Required, please enter sequence',
      optionalRemark: 'Optional, please enter remark',
      requiredComponentId: 'Component ID is required',
      maxComponentId: 'Component ID cannot exceed 30 characters',
      maxName: 'Name cannot exceed 64 characters',
      maxHoldpace: 'Holdpace cannot exceed 64 characters',
      maxParam: 'Param cannot exceed 64 characters',
      maxType: 'Type cannot exceed 12 characters',
      numberSeq: 'Sequence must be a number',
      maxRemark: 'Remark cannot exceed 512 characters',
      requiredConditionId: 'Condition ID is required',
      confirmDelete: 'Are you sure to delete this component condition?'
    }
  },
  zh: {
    componentConditionManage: {
      condition: '条件',
      conditionId: '条件ID',
      name: '名称',
      holdpace: '提示',
      param: '参数',
      type: '类型',
      seq: '序号',
      remark: '描述',
      text: '文本框',
      date: '日期',
      fetchError: '获取组件条件失败',
      requiredName: '必填，请填写名称',
      requiredHoldpace: '必填，请填写提示',
      requiredParam: '必填，请填写参数',
      requiredType: '必填，请选择类型',
      requiredSeq: '必填，请填写序号',
      optionalRemark: '选填，请填写描述',
      requiredComponentId: '组件ID不能为空',
      maxComponentId: '组件ID不能超过30',
      maxName: '名称不能超过64',
      maxHoldpace: '提示不能超过64',
      maxParam: '参数不能超过64',
      maxType: '类型不能超过12',
      numberSeq: '序号必须是数字',
      maxRemark: '描述不能超过512',
      requiredConditionId: '条件ID不能为空',
      confirmDelete: '确定删除该组件条件吗？'
    }
  }
}